(function () {
  var CONFIG = {
    debugParam: "cipa_debug=1",

    // Only add Google IDs here when they are NOT already installed through Shopify Web Pixels.
    supplementalGoogleTagIds: ["AW-992959280"],

    // Only add GTM containers here when they are store-specific and still required.
    supplementalGtmContainerIds: ["GTM-PXJ7HMNJ"],

    // Only add Meta pixel IDs here when they are NOT already installed through Shopify Web Pixels.
    supplementalMetaPixelIds: [],

    enableKlaviyoFormsAfterConsent: false,
    enableKlaviyoTrackingAfterConsent: false,
    enableKlaviyoBIS: false,
    klaviyo: {
      companyId: "",
      bisListId: "",
      excludeOnTags: "bis-hidden"
    }
  };

  var DEBUG = window.location.search.indexOf(CONFIG.debugParam) !== -1;
  var marketingCallbacks = [];
  var marketingStarted = false;
  var gtagConfigured = false;
  var metaConfigured = false;
  var klaviyoFormsStarted = false;
  var klaviyoTrackingStarted = false;
  var klaviyoBISStarted = false;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ["[CIPA Gate]"].concat([].slice.call(arguments))); } catch (e) {}
  }

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function marketingAllowed() {
    var cp = customerPrivacy();
    return !!(cp && cp.marketingAllowed && cp.marketingAllowed());
  }

  function preferencesAllowed() {
    var cp = customerPrivacy();
    return !!(cp && cp.preferencesProcessingAllowed && cp.preferencesProcessingAllowed());
  }

  function waitForConsentApi(callback) {
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        callback && callback();
      });
      return;
    }

    setTimeout(function () {
      waitForConsentApi(callback);
    }, 50);
  }

  function loadScriptOnce(id, src, onload) {
    var existing = document.getElementById(id);

    if (existing) {
      if (existing.getAttribute("data-cipa-loaded") === "true") {
        if (typeof onload === "function") onload();
      } else if (typeof onload === "function") {
        existing.addEventListener("load", onload);
      }
      return;
    }

    var script = document.createElement("script");
    script.id = id;
    script.async = true;
    script.src = src;
    script.onload = function () {
      script.setAttribute("data-cipa-loaded", "true");
      if (typeof onload === "function") onload();
    };

    document.head.appendChild(script);
    log("Injected:", id, src);
  }

  function onMarketingConsent(callback) {
    if (typeof callback !== "function") return;

    if (marketingAllowed()) {
      callback();
      return;
    }

    marketingCallbacks.push(callback);
  }

  function flushMarketingCallbacks() {
    if (!marketingAllowed()) return;

    while (marketingCallbacks.length) {
      try { marketingCallbacks.shift()(); } catch (e) { log("Consent callback failed:", e); }
    }
  }

  function cleanIds(ids) {
    var out = [];
    var seen = {};

    for (var i = 0; i < ids.length; i++) {
      var id = String(ids[i] || "").replace(/^\s+|\s+$/g, "");
      if (!id || seen[id]) continue;
      seen[id] = true;
      out.push(id);
    }

    return out;
  }

  function hasGtagScript() {
    return !!document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
  }

  function configureSupplementalGtmContainers() {
    var ids = cleanIds(CONFIG.supplementalGtmContainerIds || []);
    if (!ids.length) return;

    window.dataLayer = window.dataLayer || [];

    for (var i = 0; i < ids.length; i++) {
      (function (id) {
        var scriptId = "cipa-gtm-" + id.replace(/[^A-Za-z0-9_-]/g, "-");
        if (document.getElementById(scriptId)) return;

        window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        loadScriptOnce(
          scriptId,
          "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(id),
          function () { log("Supplemental GTM container loaded:", id); }
        );
      })(ids[i]);
    }
  }

  function configureSupplementalGoogleTags() {
    var ids = cleanIds(CONFIG.supplementalGoogleTagIds || []);
    if (!ids.length || gtagConfigured) return;
    gtagConfigured = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    function configTags() {
      window.gtag("js", new Date());
      for (var i = 0; i < ids.length; i++) {
        window.gtag("config", ids[i]);
      }
      log("Supplemental Google tags configured:", ids);
    }

    if (hasGtagScript()) {
      configTags();
      return;
    }

    loadScriptOnce(
      "cipa-supplemental-gtag",
      "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(ids[0]),
      configTags
    );
  }

  function ensureFbq() {
    if (window.fbq && window.fbq.callMethod) return;

    var fbq = window.fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };

    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
  }

  function configureSupplementalMetaPixels() {
    var ids = cleanIds(CONFIG.supplementalMetaPixelIds || []);
    if (!ids.length || metaConfigured) return;
    metaConfigured = true;

    ensureFbq();

    for (var i = 0; i < ids.length; i++) {
      window.fbq("init", ids[i]);
      window.fbq("trackSingle", ids[i], "PageView");
    }

    loadScriptOnce("facebook-jssdk", "https://connect.facebook.net/en_US/fbevents.js", function () {
      log("Supplemental Meta pixels configured:", ids);
    });
  }

  function initKlaviyoBIS() {
    window.klaviyo = window.klaviyo || [];

    var tries = 0;
    (function waitForKlaviyoBIS() {
      tries++;

      if (typeof window.klaviyo.init !== "function" || typeof window.klaviyo.enable !== "function") {
        if (tries < 80) return setTimeout(waitForKlaviyoBIS, 100);
        log("Klaviyo BIS timed out waiting for init/enable");
        return;
      }

      window.klaviyo.init({
        account: CONFIG.klaviyo.companyId,
        list: CONFIG.klaviyo.bisListId,
        platform: "shopify",
        exclude_on_tags: CONFIG.klaviyo.excludeOnTags
      });

      window.klaviyo.enable("backinstock", {
        trigger: {
          product_page_text: "Notify Me When Available",
          product_page_class: "btn",
          product_page_text_align: "center",
          product_page_margin: "0px",
          replace_anchor: false
        },
        modal: {
          headline: "{product_name}",
          body_content: "Register to receive a notification when this item comes back in stock.",
          email_field_label: "Email",
          button_label: "Notify me when available",
          subscription_success_label: "You're in! We'll let you know when it's back.",
          footer_content: "",
          drop_background_color: "#000",
          background_color: "#fff",
          text_color: "#222",
          button_text_color: "#fff",
          button_background_color: "#000",
          close_button_color: "#ccc",
          error_background_color: "#fcd6d7",
          error_text_color: "#C72E2F",
          success_background_color: "#d3efcd",
          success_text_color: "#1B9500",
          subscribe_checked: false
        }
      });

      log("Klaviyo BIS initialized");
    })();
  }

  function loadKlaviyoForms() {
    if (!CONFIG.enableKlaviyoFormsAfterConsent || klaviyoFormsStarted) return;
    klaviyoFormsStarted = true;

    // Loads Klaviyo onsite signup forms/popups only after marketing consent.
    // Klaviyo tracking events are queued separately after marketing consent.
    loadScriptOnce(
      "klaviyo-forms-runtime",
      "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + encodeURIComponent(CONFIG.klaviyo.companyId),
      function () { log("Klaviyo forms runtime loaded"); }
    );
  }

  function ensureLearnq() {
    window._learnq = window._learnq || [];
  }

  function dedup(key) {
    window.__CIPA_DEDUP = window.__CIPA_DEDUP || {};
    if (window.__CIPA_DEDUP[key]) return true;
    window.__CIPA_DEDUP[key] = true;
    return false;
  }

  function learnqPush(arr) {
    ensureLearnq();

    if (DEBUG) {
      if (arr && arr[0] === "track") log("Klaviyo track:", arr[1], arr[2] || {});
      else if (arr && arr[0] === "identify") log("Klaviyo identify:", arr[1] || {});
      else log("Klaviyo queue:", arr);
    }

    try { window._learnq.push(arr); } catch (e) { log("Klaviyo queue failed:", e); }
  }

  function identifyCustomer() {
    if (!window.__CIPA_KLAVIYO_CUSTOMER || dedup("kl_identify")) return;
    learnqPush(["identify", window.__CIPA_KLAVIYO_CUSTOMER]);
  }

  function trackActiveOnSite() {
    if (dedup("kl_active_on_site")) return;
    learnqPush(["track", "Active on Site"]);
  }

  function trackViewedProduct() {
    var product = window.__CIPA_KLAVIYO_VIEWED_PRODUCT;
    if (!product) return;
    if (product.ProductID && dedup("kl_viewed_product:" + product.ProductID)) return;
    learnqPush(["track", "Viewed Product", product]);
  }

  function trackViewedCollection() {
    var collection = window.__CIPA_KLAVIYO_VIEWED_COLLECTION;
    if (!collection) return;
    if (collection.CollectionID && dedup("kl_viewed_collection:" + collection.CollectionID)) return;
    learnqPush(["track", "Viewed Collection", collection]);
  }

  function installSearchListener() {
    if (window.__cipa_search_listener) return;
    window.__cipa_search_listener = true;

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form) return;

      var isSearch =
        (form.action && form.action.indexOf("/search") !== -1) ||
        form.querySelector('input[name="q"]');

      if (!isSearch) return;

      var input = form.querySelector('input[name="q"]');
      var query = input ? (input.value || "").trim() : "";
      if (!query) return;

      learnqPush(["track", "Searched Site", { Query: query, URL: window.location.href }]);
    }, true);
  }

  function installCartHooks() {
    if (window.__cipa_cart_hooks) return;
    window.__cipa_cart_hooks = true;

    function kindForUrl(url) {
      if (!url) return "";
      try { url = String(url); } catch (e) { return ""; }

      if (url.indexOf("/cart/add") !== -1) return "add";
      if (url.indexOf("/cart/change") !== -1) return "change";
      if (url.indexOf("/cart/update") !== -1) return "update";
      if (url.indexOf("/cart?") !== -1 && url.indexOf("view=ajax") !== -1) return "ajax_refresh";
      return "";
    }

    function trackCart(kind) {
      if (kind === "add") {
        learnqPush(["track", "Added to Cart", window.__CIPA_KLAVIYO_VIEWED_PRODUCT || { URL: window.location.href }]);
        return;
      }

      learnqPush(["track", "Cart Updated", { URL: window.location.href }]);
    }

    if (window.fetch && !window.__cipa_fetch_wrapped) {
      window.__cipa_fetch_wrapped = true;
      var originalFetch = window.fetch;

      window.fetch = function () {
        var args = arguments;
        var request = args[0];
        var url = typeof request === "string" ? request : (request && request.url);
        var kind = kindForUrl(url);

        return originalFetch.apply(this, args).then(function (response) {
          if (kind) trackCart(kind);
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !window.__cipa_xhr_wrapped) {
      window.__cipa_xhr_wrapped = true;
      var XHR = window.XMLHttpRequest;
      var open = XHR.prototype.open;
      var send = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__cipa_kind = kindForUrl(url);
        return open.apply(this, arguments);
      };

      XHR.prototype.send = function () {
        var xhr = this;
        xhr.addEventListener("load", function () {
          if (xhr.__cipa_kind) trackCart(xhr.__cipa_kind);
        });
        return send.apply(this, arguments);
      };
    }

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      if (form.action.indexOf("/cart/add") === -1) return;
      trackCart("add");
    }, true);
  }

  function installCheckoutListener() {
    if (window.__cipa_checkout_listener) return;
    window.__cipa_checkout_listener = true;

    function isCheckoutHref(href) {
      return !!(href && href.indexOf("/checkout") !== -1);
    }

    document.addEventListener("click", function (event) {
      var element = event.target && event.target.closest ? event.target.closest("a,button") : null;
      if (!element) return;

      if (element.tagName === "A") {
        var href = element.getAttribute("href") || "";
        if (isCheckoutHref(href)) {
          learnqPush(["track", "Started Checkout", { URL: window.location.href }]);
          return;
        }
      }

      var text = (element.textContent || "").toLowerCase();
      var id = (element.id || "").toLowerCase();
      var className = (element.className || "").toLowerCase();
      var name = (element.getAttribute("name") || "").toLowerCase();

      if (text.indexOf("checkout") !== -1 || id.indexOf("checkout") !== -1 || className.indexOf("checkout") !== -1 || name.indexOf("checkout") !== -1) {
        learnqPush(["track", "Started Checkout", { URL: window.location.href }]);
      }
    }, true);

    if (window.location && window.location.pathname && window.location.pathname.indexOf("/checkout") === 0) {
      learnqPush(["track", "Started Checkout", { URL: window.location.href }]);
    }
  }

  function installKlaviyoTracking() {
    if (!CONFIG.enableKlaviyoTrackingAfterConsent || klaviyoTrackingStarted) return;
    klaviyoTrackingStarted = true;

    ensureLearnq();
    identifyCustomer();
    trackActiveOnSite();
    trackViewedProduct();
    trackViewedCollection();
    installSearchListener();
    installCartHooks();
    installCheckoutListener();

    log("Klaviyo tracking installed");
  }

  function loadKlaviyoBIS() {
    if (!CONFIG.enableKlaviyoBIS || klaviyoBISStarted) return;
    klaviyoBISStarted = true;

    // BIS is a functional, user-initiated product alert helper. Passive
    // Klaviyo tracking stays in the post-consent tracking path above.
    loadScriptOnce("klaviyo-onsite-bis", "https://a.klaviyo.com/media/js/onsite/onsite.js", initKlaviyoBIS);
  }

  function startMarketingVendors() {
    if (!marketingAllowed() || marketingStarted) return;
    marketingStarted = true;

    log("Marketing consent granted");
    configureSupplementalGtmContainers();
    configureSupplementalGoogleTags();
    configureSupplementalMetaPixels();
    loadKlaviyoForms();
    installKlaviyoTracking();
    flushMarketingCallbacks();
  }

  function debugState() {
    return {
      marketingAllowed: marketingAllowed(),
      preferencesAllowed: preferencesAllowed(),
      supplementalGoogleTagIds: cleanIds(CONFIG.supplementalGoogleTagIds || []),
      supplementalGtmContainerIds: cleanIds(CONFIG.supplementalGtmContainerIds || []),
      supplementalMetaPixelIds: cleanIds(CONFIG.supplementalMetaPixelIds || []),
      geoTargetlyLoadedOutsideGate: !!document.getElementById("geotargetly-script"),
      klaviyoFormsLoaded: !!document.getElementById("klaviyo-forms-runtime"),
      klaviyoTrackingInstalled: klaviyoTrackingStarted,
      klaviyoBISLoaded: !!document.getElementById("klaviyo-onsite-bis"),
      shopifyCustomerPrivacy: !!customerPrivacy()
    };
  }

  function donePolling() {
    return marketingStarted;
  }

  window.CIPAConsent = window.CIPAConsent || {};
  window.CIPAConsent.hasMarketingConsent = marketingAllowed;
  window.CIPAConsent.hasPreferencesConsent = preferencesAllowed;
  window.CIPAConsent.onMarketingConsent = onMarketingConsent;
  window.CIPAConsent.loadScriptOnce = loadScriptOnce;
  window.CIPAConsent.debug = debugState;

  loadKlaviyoBIS();

  waitForConsentApi(function () {
    startMarketingVendors();
    document.addEventListener("visitorConsentCollected", function () {
      startMarketingVendors();
    });

    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      startMarketingVendors();
      if (tries > 150 || donePolling()) clearInterval(poll);
    }, 100);

    log("Initialized:", debugState());
  });
})();
